<div class="monitor-dashboard-kpi-grid">
  <div class="monitor-dashboard-kpi-item">
    <div class="shadow bg-white rounded monitor-dashboard-kpi-card">
      <b>{{$t('monitorDashboard.allComplaints')}}</b>
      <div class="mt-2" v-if="!isLoading">
        <b class="color-Main fs-20">{{ displayCount(kpis.allComplaints) }}</b>
      </div>
      <div class="mt-2 monitor-dashboard-kpi-skeleton" v-else role="status" aria-live="polite">
        <span class="sr-only">{{ $t('monitorDashboard.loading') }}</span>
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line monitor-dashboard-skeleton-line--kpi"
          aria-hidden="true"></div>
      </div>
    </div>
  </div>

  <div class="monitor-dashboard-kpi-item">
    <div class="shadow bg-white rounded monitor-dashboard-kpi-card">
      <b>{{$t('monitorDashboard.pendingComplaints')}}</b>
      <div class="mt-2" v-if="!isLoading">
        <b class="color-Main fs-20">{{ displayCount(kpis.pendingComplaints) }}</b>
      </div>
      <div class="mt-2 monitor-dashboard-kpi-skeleton" v-else role="status" aria-live="polite">
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line monitor-dashboard-skeleton-line--kpi"
          aria-hidden="true"></div>
      </div>
    </div>
  </div>

  <div class="monitor-dashboard-kpi-item">
    <div class="shadow bg-white rounded monitor-dashboard-kpi-card">
      <b>{{$t('monitorDashboard.resolvedComplaints')}}</b>
      <div class="mt-2" v-if="!isLoading">
        <b class="color-Main fs-20">{{ displayCount(kpis.resolvedComplaints) }}</b>
      </div>
      <div class="mt-2 monitor-dashboard-kpi-skeleton" v-else role="status" aria-live="polite">
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line monitor-dashboard-skeleton-line--kpi"
          aria-hidden="true"></div>
      </div>
    </div>
  </div>

  <div class="monitor-dashboard-kpi-item">
    <div class="shadow bg-white rounded monitor-dashboard-kpi-card">
      <b>{{$t('monitorDashboard.complaintsProcessingAverage')}}</b>
      <div class="mt-2 mb-3" v-if="!isLoading">
        <b class="color-Main fs-20">{{ formatDays(kpis.avgProcessingBusinessDays) }}</b>
      </div>
      <div class="mt-2 monitor-dashboard-kpi-skeleton" v-else role="status" aria-live="polite">
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line monitor-dashboard-skeleton-line--kpi"
          aria-hidden="true"></div>
      </div>
    </div>
  </div>
</div>
